<template>
    <div>
        <input type="file" id="myFileInput" class="hide" @change="change" multiple />
        <div 
            v-if="files.length == 0"
            class="text-center drag-area p-5" 
            @drop='onDrop($event)'
            @dragover="onDragOver($event)"
            @click="selectFiles">
            <h4>Arraste e Solte os Arquivos<br/>ou</h4>
            <label class="btn btn-lg btn-primary">Selecione Arquivos</label>
        </div>

        <arquivo-table 
            :key="arquivoTableKey"
            :files="files"
            @update="callUpdate"
            @destroy="destroy">
        </arquivo-table>

        <div class="form-row" v-if="files.length > 0">
            <div class="form-group col-md-12">
                <button class="btn btn-primary" @click="upload">Enviar</button>
            </div>
        </div>

        <arquivo-update
            :file="file"
            @update="update">
        </arquivo-update>
    </div>
</template>

<script>
    export default {
        data(){
            return {
                file: '',
                files: [],
                filesInput: [],
                filesSrc: [],
                arquivoTableKey: 1
            }
        },
        methods: {
            selectFiles(){
                document.getElementById('myFileInput').click()
            },
            async change(){
                this.filesInput = document.getElementById('myFileInput').files;
                await this.getFilesSrc();
            },
            async getFilesSrc(){
                let filesSrc = [];
                for (let i=0; i<this.filesInput.length; i++) {
                    let reader = new FileReader();
                    reader.onload = function (e) {
                        filesSrc.push(e.target.result);
                    }
                    reader.readAsDataURL(this.filesInput[i]);
                }
                this.filesSrc = filesSrc;
            },
            onDragOver(e){
                e.preventDefault();
            },
            async onDrop(e){
                e.preventDefault();
                this.filesInput = e.dataTransfer.files;
                await this.getFilesSrc();
            },
            setFiles(){
                if(this.filesSrc.length == this.filesInput.length){
                    this.files = this.filesInput;
                    for(let i=0; i<this.filesSrc.length; i++) {
                        this.files[i]['src'] = this.filesSrc[i];
                        this.files[i]['nome'] = this.files[i]['name'];
                    }
                }
            },
            callUpdate(file){
                this.file = file;
                $('#update_arquivo').modal('show');
            },
            upload(){
                this.$emit('upload', this.files);
            },
            update(name){
                for(let i=0; i<this.files.length; i++) {
                    if(this.files[i] == this.file){
                        this.files[i]['nome'] = name;
                    }
                }
                this.arquivoTableKey += 1
            },
            destroy(file){
                var newFiles = [];
                for(let i=0; i<this.files.length; i++) {
                    if(this.files[i] != file){
                        newFiles.push(this.files[i]);
                    }
                }
                this.files = newFiles;
                this.arquivoTableKey += 1;
            }
        },
        watch: {
            filesSrc(){
                this.setFiles()
            },
            files(){
                this.arquivoTableKey += 1
            }
        }
    }
</script>

<style scoped>
    .hide {
        display:none;
    }
    .drag-area:hover {
        background-color: #D8D8D8;
        cursor: pointer;
    }
</style>